import React from 'react';
import { signOut } from '../../../service/common/firebase';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../store/reducer-main';
import { ProductWithPrice } from '../../../types/stripe';
import { initPurchaseSessionCF } from '../../../service/common/stripe';
import PageLayout from '../../components/common/PageLayout';
import PurchaseSessionStepsHeader from '../../components/common/PurchaseSessionStepsHeader';
import { PurchaseSessionStep } from '../../../constants/purchaseSession';
import AdminDataFooter from '../../components/common/AdminDataFooter';
import Typography from '../../components/common/Typography';
import ReducedProductCard from '../../components/common/ReducedProductCard';
import { getPlanRecurringPeriod } from '../../../helpers/stripeUtils';
import ProductRecapCard from '../../components/purchase/ProductRecapCard';
import IconButton from '../../components/common/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import theme from '../../theme';
import { loadPurchaseSession, resetPurchaseSession, selectedPurchaseSessionProduct } from '../../../store/purchaseSession/slice';

export default function SelecteProductPage() {

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { product, session } = useSelector((state: StoreState) => state.purchaseSession);
  const { products, loadingProducts } = useSelector((state: StoreState) => state.stripe);
  const { userProfile } = useSelector((state: StoreState) => state.profile);

  const [promoCode, setPromoCode] = React.useState<string>('');
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!product && products) {
      onProductSelect(products[0]);
    }
  }, [products])

  const onProductSelect = (
    p: ProductWithPrice
  ) => {
    dispatch(selectedPurchaseSessionProduct(p));
  }

  const onProceed = async () => {
    if (!userProfile) return;
    const sessionStillValid = isPurchaseSessionStillValid();
    if (!sessionStillValid) {
      setLoading(true);
      dispatch(resetPurchaseSession());
      const stripeCustomerId = userProfile.stripeCustomer.id;
      console.log("PRODUCT ❤️❤️❤️❤️❤️", product)
      const newPurchaseSession = await initPurchaseSessionCF({product:product as ProductWithPrice, stripeCustomerId}); 
      console.log("newPurchaseSession ❤️❤️❤️❤️❤️", newPurchaseSession)
      console.log({newPurchaseSession});
      dispatch((loadPurchaseSession(newPurchaseSession)));
    }
    setTimeout(() => {
      navigate('/purchase/checkout');
      setLoading(false);
    }, 1000)
  }

  const isPurchaseSessionStillValid = (): boolean => {
    if (!product || !session) return false;
    if (session.product.id !== product.id) return false;
    return true;
  }

  return (
    <PageLayout bg='background'>
      <PurchaseSessionStepsHeader
        selectedStep={PurchaseSessionStep.PRODUCTS} />
      <div className='flex flex-col flex-1 justify-center items-center'>
        {
          !products
            ? loadingProducts
              ? <Typography>Caricamento dei prodotti...</Typography>
              : <Typography>Si è verificato un errore nel caricamento dei prodotti</Typography>
            : (
              <div className='flex flex-col px-16 gap-8'>
                <div className='flex items-center gap-4'>
                  <IconButton 
                    onClick={signOut}
                    icon={<ArrowBackIcon style={{color: theme.color.background}}/>} />
                  <div className='flex flex-col'>
                    <Typography variant='headline2'>Pacchetti disponibili</Typography>
                    <Typography>Selezionare il prodotto che desideri acquistare</Typography>
                  </div>
                </div>
              <div className='flex flex-row gap-40'>
                <div className='flex flex-col gap-4 flex-1' style={{maxWidth: '900px', minWidth: '600px'}}>
                  {
                    products.map(prod => (
                      <ReducedProductCard 
                        key={prod.id}
                        productName={prod.name}
                        onPress={() => onProductSelect(prod)}
                        productDescription={prod.description}
                        recurringPeriod={getPlanRecurringPeriod(prod.default_price)}
                        price={`${((prod.default_price.unit_amount ?? 0) / 100).toFixed(2).replace('.', ',')} €`}
                        selected={prod.id === product?.id} />
                    ))
                  }
                </div>
                <div style={{maxWidth: '900px', minWidth: '650px', marginTop: 'auto', marginBottom: 'auto'}}>
                  {
                    product && (
                      <ProductRecapCard
                        style={{maxWidth: '400px'}}
                        loading={loading}
                        onSubmit={onProceed}
                        product={product}
                        submitTitle='INIZIA'
                        onPromoCodeChange={setPromoCode}
                        promoCode={promoCode} 
                        submitVariant='primary'/>
                    )
                  }
                </div>
              </div>
              </div>
            )
        }
        
      </div>
      <AdminDataFooter colorVariant='text' />
    </PageLayout>
  )
}